import React from 'react';

import { StyleSheet, View, Platform } from 'react-native';

import InputNumber from './InputNumber';
import Text from '../text/Text';

const InputNumberPrefixed = ({
	prefix,
	...passThroughProps
}) => (
	<View
		style={{
			position: 'relative',
		}}
	>
		<Text
			style={[styles.prefixStyle, { top: Platform.OS === 'ios' ? 8 : 7 }]}
		>
			{ prefix }
		</Text>
		<InputNumber
			{...passThroughProps}
		/>
	</View>
);

const styles = StyleSheet.create({
	prefixStyle: {
		position: 'absolute',
		left: 5,
		zIndex: 10,
	},
});


export default React.memo(InputNumberPrefixed);
